/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

/**
 0	Emergency	emerg	panic. System is unusable
 1	Alert	alert	Action must be taken immediately
 2	Critical	critCritical conditions	Hard device errors.[8]
 3	Error	err	error	Error conditions
 4	Warning	warning	warn.	Warning conditions
 5	Notice	notice. Normal but significant conditions
 6	Informational	info.	Informational messages
 7	Debug	debug.	Debug-level messages
 */
 export enum LEVEL {
  EMERGENCY = 0,
  ALERT = 1,
  CRITICAL = 2,
  ERROR = 3,
  WARNING = 4,
  NOTICE = 5,
  INFO = 6,
 }

type DetailData = Record<string, unknown>;

interface Actor<T = DetailData> {
  id: string;
  type: string; // E.g: 'User' | 'System'
  alternateId?: string;
  displayName?: string;
  detailEntry?: T;
}

interface UserAgent {
  rawUserAgent: string;
  os?: string;
  browser?: string;
}

interface GeographicalContext {
  city: string; // London
  state: string; // England
  country: string; // gb
  postalCode: string; // ES1
  geolocation: {
    lat: number;
    lon: number;
  };
}

interface AuditClient {
  userAgent: UserAgent;
  // zone: string;
  device?: string;
  id?: string;
  ipAddress: string;
  geographicalContext?: GeographicalContext;
}

interface Outcome {
  result: 'SUCCESS' | 'ERROR' | 'ALLOW';  // result	"ALLOW"
  reason?: string; // reason	"Sign-on policy evaluation resulted in ALLOW"
}

interface OutcomeAuditData {
  outcome: Outcome;
  event: string; // 'user_created' | 'registered' ...
  message: string; // "User single sign on to app"
  severity: LEVEL; // Standard Log - ERROR = 3,WARNING = 4,NOTICE = 5 etc.
  targets: Actor[];
}

interface Transaction {
  type: 'WEB';
  id: string;
  detail?: DetailData;
}
interface DebugContext {
  debugData: {
    requestId: string; // generated id
    requestUri: string; // path
    url: string; // path with query
  };
}

enum Operation {
  Access = 'access',
  Authentication = 'authentication',
  Create = 'create',
  Modify = 'modify',
  Remove = 'remove',
  Restore = 'restore',
  Transfer = 'transfer',
}

interface CreateAuditEntry extends OutcomeAuditData {
  // Could be combined into eventType = 'user.user_created' or 'user.created'
  service: string; // 'user' | 'onboarding'
  operation: Operation

  // Associate for specific org & level
  organizationId?: string; // Who it belongs to?

  // Specific reporting level
  initiativeId?: string;

  actor: Actor;

  client: AuditClient;
  transaction: Transaction;
  debugContext: DebugContext;
  eventDate: Date;
}

export interface AuditEvent {
  service: string;
  code: string;

  // Human-readable generic name of the event
  name: string;
  description?: string;
  link?: string;
}


export interface AuditLogEntry extends CreateAuditEntry {
  _id: string,
  actor: Actor,
  auditEvent?: AuditEvent
  initiativeId: string,
}
